<template>
  <div class="grid">
    <div class="col-12">
      <BaseInput
        :modelValue="rssUrl"
        @update:modelValue="$emit('update:rssUrl', $event)"
        :fieldId="rssUrlFieldName"
        :fieldName="rssUrlFieldName"
        fieldLabel="RSS Feed URL"
        @blur="$emit('blurRssUrl', $event)"
      >
        <template #helperText>
          <small :id="`${rssUrlFieldName}-help`">
            Enter your podcast RSS feed URL. This will try to import your settings to the form.
          </small>
        </template>
      </BaseInput>
    </div>
    <div class="col-12">
      <BaseInput
        :modelValue="name"
        @update:modelValue="$emit('update:name', $event)"
        :fieldId="nameFieldName"
        :fieldName="nameFieldName"
        fieldLabel="Podcast Name"
      />
    </div>
    <div class="col-12 md:col-6">
      <BaseInput
        :modelValue="hostName"
        @update:modelValue="$emit('update:hostName', $event)"
        :fieldId="hostNameFieldName"
        :fieldName="hostNameFieldName"
        fieldLabel="Host Name"
      />
    </div>
    <div class="col-12 md:col-6">
      <BaseInput
        :modelValue="hostEmail"
        @update:modelValue="$emit('update:hostEmail', $event)"
        :fieldId="hostEmailFieldName"
        :fieldName="hostEmailFieldName"
        fieldLabel="Contact Email"
        type="email"
      />
    </div>
    <div class="col-12">
      <Message
        class="mt-1 mb-2"
        severity="info"
        icon="pi pi-info-circle"
        :closable="false"
        :pt="{
          icon: {
            class: 'mt-1 text-xl align-self-start',
          },
          text: {
            class: 'font-normal text-sm',
          },
        }"
      >
        As a manual provider, you will need to copy and paste campaign details
        (VAST tag, CPM, dates, etc.) into your own ad serving system after
        approving each campaign.
      </Message>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rssUrl: String,
    name: String,
    hostName: String,
    hostEmail: String,
    rssUrlFieldName: {
      type: String,
      default: 'rssUrl',
    },
    nameFieldName: {
      type: String,
      default: 'name',
    },
    hostNameFieldName: {
      type: String,
      default: 'hostName',
    },
    hostEmailFieldName: {
      type: String,
      default: 'hostEmail',
    },
  },
};
</script>
